import { Autoplay, KeyboardScope, LogLevel, PerformanceMode } from '@cbsinteractive/avia-js';
import { blankMP4Base64 } from 'library/ts/utilities/Autoplay';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { PlayerLoadingTimeout } from 'tag/ts/tag/model/type/PlayerLoadingTimeout';
import { AviaPluginsManager } from 'tag/ts/tag/player/adapters/avia/plugins/AviaPluginsManager';
import { STVPlatformConfigs } from 'tag/ts/tag/player/stv/configs/STVPlatformConfigs';
export class AviaPlayerOptionsManager extends AbstractTagClass {
    #tagConfigImports;
    #pluginManager;
    constructor(argument) {
        super({
            ...argument,
            name: 'AviaPlayerOptionsManager'
        });
        this.#tagConfigImports = this.tag?.model?.config?.tag?.Imports?.params;
        this.#pluginManager = new AviaPluginsManager({ tag: argument?.tag });
    }
    getPlayerOptions = (container) => {
        return new Promise((resolve, reject) => {
            let playerOptions = {
                container: container,
                keyboard: {
                    scope: KeyboardScope.NONE
                }
            };
            if (this.runtimeVO.debug.player === true || this.runtimeVO.debug.lowLevel === true) {
                playerOptions.logLevel = LogLevel.DEBUG;
            }
            playerOptions.network = {
                timeout: PlayerLoadingTimeout.NETWORK
            };
            playerOptions.performanceMode = PerformanceMode.AUTO;
            switch (this.params.SKIN.enabled) {
                case true:
                    playerOptions.autoplay = Autoplay.ATTEMPT_UNMUTED_THEN_MUTED;
                    playerOptions.renderTextTrackNatively = this.params.SKIN.defaultSkin || this.capabilities.isMobile.any();
                    break;
                case false:
                    playerOptions.autoplay = Autoplay.ATTEMPT_UNMUTED_THEN_MUTED;
                    playerOptions.renderTextTrackNatively = (this.params.SYSTEM.embedType === EmbedType.DESKTOP);
                    break;
            }
            this.tag.model.siteUtilities.getSiteSessionData(`${this.name}.getResourceConfig`).then((sessionData) => {
                playerOptions = this.#setupPlugins(playerOptions);
                playerOptions = this.#setupMoat(playerOptions);
                playerOptions = this.#setupOpenMeasurement(playerOptions);
                playerOptions = this.#setupPlayerOptionsOverrides(playerOptions);
                playerOptions = this.#setupPlatformSpecificOptions(playerOptions);
                if (!this.utils.Type.isEmpty(this.params?.TAG?.playerOptions)
                    &&
                        this.utils.Type.isObject(this.params?.TAG?.playerOptions)) {
                    playerOptions = this.utils.DeepMerge.deepmerge(playerOptions, this.params?.TAG?.playerOptions);
                }
                this?.logger?.log('getPlayerOptions', 'playerOptions:', playerOptions);
                resolve({ msg: 'Player options', result: playerOptions });
            });
        });
    };
    #setupPlugins = (playerOptions) => {
        playerOptions.plugins = this.#pluginManager.getAllPlugins() || [];
        this?.logger?.log('playerOptions.plugins setup complete', playerOptions.plugins);
        return playerOptions;
    };
    #pluginsPlaceholdersCheck = (playerOptions) => {
        if (!this.utils.Type.isArray(playerOptions?.plugins)) {
            playerOptions.plugins = [];
        }
        return playerOptions;
    };
    #setupMoat = (playerOptions) => {
        playerOptions.enableMoat = false;
        return playerOptions;
    };
    #setupOpenMeasurement = (playerOptions) => {
        playerOptions.enableOm = true;
        return playerOptions;
    };
    #setupPlayerOptionsOverrides = (playerOptions) => {
        if (this.utils.Type.isEmpty(playerOptions?.overrides)) {
            playerOptions.overrides = {};
        }
        playerOptions.overrides.blankVideoUrl = blankMP4Base64;
        return playerOptions;
    };
    #setupPlatformSpecificOptions = (playerOptions) => {
        if (this?.params?.SYSTEM?.embedType === EmbedType.HTML5) {
            const platformSpecificOptions = new STVPlatformConfigs({ tag: this?.tag });
            this?.logger?.log('setupPlatformSpecificOptions', 'PLATFORM CONFIGS:', platformSpecificOptions?.playerOptions);
            playerOptions = this.utils.DeepMerge.deepmerge(playerOptions, platformSpecificOptions?.playerOptions);
        }
        return playerOptions;
    };
}
